import { CookieTypes, CookieTypesEnum } from "./cookieUtilities";
import { containsAny } from "./stringUtilities";

export class MonsidoUtilities {
  static trackingFunctions: { [key: string]: () => void } = {};

  isConsented(type: CookieTypesEnum): boolean {
    if (!this.mcmLoaded()) {
      return false;
    }

    const consentedCookieTypes = window.monsidoConsentManager.cookiesConsent
      .cookies as CookieTypes;
    return consentedCookieTypes.includes(type);
  }

  mcmLoaded(): boolean {
    return window.monsidoConsentManager !== undefined;
  }

  trackEvent(category: string, action: string, name: string) {
    if (this.isConsented(CookieTypesEnum.Analytics)) {
      window.monsido_functions.trackEvent(category, action, name, 1);
    }
  }

  // Method that retries Monsido event tracking in cases where race conditions emerge between e.g. redirects and loading of the Monsido module
  async trackDirectAccessWithRetry(category: string, action: string, name: string, maxRetries = 5, baseDelay = 100) {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      if (
        window.monsido_functions &&
        typeof window.monsido_functions.trackEvent === "function"
      ) {
        monsidoUtilities.trackEvent(
          category,
          action,
          name
        );
        return;
      }

      // Wait before retrying (exponential backoff to maximize chance for Monsido module to load)
      if (attempt < maxRetries - 1) {
        const delay = baseDelay * Math.pow(2, attempt);
        console.log(`Retrying in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }

  updateMonsidoEventTracker(
    el: HTMLAnchorElement,
    key: string,
    title: string
  ): void {
    if (!this.isConsented(CookieTypesEnum.Analytics)) {
      this.removeMonsidoEventTracker(el, key);
      return;
    }

    if (MonsidoUtilities.trackingFunctions[key]) {
      return;
    }

    const trackingFunction = () => {
      window.monsido_functions.trackEvent(
        TrackingTexts.DownloadEventCategory,
        "Download af Umbraco-dokument",
        `Download af dokument: ${title}`,
        1
      );
    };

    MonsidoUtilities.trackingFunctions[key] = trackingFunction;

    el.addEventListener("click", trackingFunction);
  }

  removeMonsidoEventTracker(el: HTMLAnchorElement, key: string): void {
    if (!MonsidoUtilities.trackingFunctions[key]) {
      return;
    }

    MonsidoUtilities.trackingFunctions[key];

    el.removeEventListener("click", MonsidoUtilities.trackingFunctions[key]);

    delete MonsidoUtilities.trackingFunctions[key];
  }

  getDocumentLinksFromRef(div: HTMLAnchorElement): HTMLAnchorElement[] {
    return [...div.querySelectorAll("a")].filter((link) => {
      return containsAny(link.href.toLowerCase(), [
        ".pdf",
        ".docx",
        ".xlsx",
        ".doc",
        ".xls",
        ".ppt",
      ]);
    });
  }
}

export const monsidoUtilities = new MonsidoUtilities();

export const TrackingTexts = {
  DownloadEventCategory: "Download",
  LogInEventCategory: "Log ind"
};